import { Data } from 'effect';

import { ErrorTag } from './index';

export class CreateOrderDidNotReturnToken extends Data.TaggedError(
  ErrorTag.CreateOrderDidNotReturnToken
)<{
  readonly message: string;
  readonly cause?: unknown;
}> {}
